import TemplateContents from './TemplateContents';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends TemplateContents{
    constructor(param){
        super(param);
    }

    init() {
        super.init();
    }

    reset(){
        super.reset();
        this.setVars();
    }

    destruct(){
        super.destruct();
        this.killMessageItemScrollTriggers();
        if (this.myCall) this.myCall.kill();
    }

    setVars(){
        super.setVars();
    }

    setDom(){
        super.setDom();
        this.root = document.querySelector('main.message');
    }

    initEvents(){
        super.initEvents();
    }

    killMessageItemScrollTriggers(){
        if (this.messageItemScrollTriggers && this.messageItemScrollTriggers.length) {
            this.messageItemScrollTriggers.forEach((st) => st.kill());
        }
        this.messageItemScrollTriggers = [];
    }

    setupMessageItemReveal(){
        this.killMessageItemScrollTriggers();
        if (!this.root) return;
        const items = this.root.querySelectorAll('.message-item');
        if (!items.length) return;
        this.messageItemScrollTriggers = [];
        items.forEach((el) => {
            const st = ScrollTrigger.create({
                trigger: el,
                start: 'top 85%',
                once: true,
                onEnter: () => el.classList.add('show'),
            });
            this.messageItemScrollTriggers.push(st);
        });
        ScrollTrigger.refresh();
    }

    start(isLanding){
        this.setupMessageItemReveal();
    }

    scrollHandler(){

    }

    enterframe(){

    }

    enterframeThinOut(){

    }

    executeResize() {
        super.executeResize();
    }
}
